/* eslint-disable @typescript-eslint/no-unused-vars */
import { createReducer, on } from '@ngrx/store';
import { EntryStoreState } from './entry.model';
import { EntryActions } from './entry.actions';
import { ClusterData, EntryData, ProviderData } from '../entry/structure-data.models';

export const ENTRY_STORE_STATE_KEY = 'entry';

const initialState: EntryStoreState = {
  accession: '',
  uniprotAccession: '',
  isUniProt: undefined,
  entryData: {} as EntryData,
  csvAmData: undefined,
  tedDomainData: [],
  clustermmseqData: {} as ClusterData,
  clusterfoldseekData: {} as ClusterData,
  uniprotData: {},
  providerData: {} as ProviderData
};

export const entryReducer = createReducer(
  initialState,
  on(EntryActions.setCurrentAccession, (state, action) => ({
    ...state,
    accession: action.accession,
  })),
  on(EntryActions.setCurrentUniprotAccession, (state, action) => ({
    ...state,
    uniprotAccession: action.uniprotAccession,
  })),
  on(EntryActions.setCurrentIsUniprot, (state, action) => ({
    ...state,
    IsUniProt: action.isUniProt,
  })),
  on(EntryActions.setCurrentProvider, (state, action) => ({
    ...state,
    providerData: action.providerData,
  })),
  on(EntryActions.getEntryDataSuccess, (state, action) => ({
    ...state,
    entryData: action.entryData,
  })),
  on(EntryActions.getCSVDataSuccess, (state, action) => ({
    ...state,
    csvAmData: action.csvAmData,
  })),
  on(EntryActions.getTedDomainDataSuccess, (state, action) => ({
    ...state,
    tedDomainData: action.tedDomainData,
  })),
  on(EntryActions.getClustermmseqSuccess, (state, action) => ({
    ...state,
    clustermmseqData: action.clustermmseqData,
  })),
  on(EntryActions.getClusterfoldseekSuccess, (state, action) => ({
    ...state,
    clusterfoldseekData: action.clusterfoldseekData,
  })),
  on(EntryActions.getUniprotDataSuccess, (state, action) => ({
    ...state,
    uniprotData: action.uniprotData,
  })),
);
